export const triggerError = (error?: unknown) => {
  if (error instanceof Error) throw error;
  if (typeof error === "string") throw new Error(error);
  throw new Error();
};
